/* eslint-disable default-param-last */
import {
  APPLIED_SAVI_ACITONS_FILTER,
  APPLIED_SAVI_SMART_FILTER,
  APPLY_SAVI_COMPANION_ACTIONS_LOAD,
  APPLY_SAVI_COMPANION_ACTIONS_SUCCESS,
  CERT_DETAILS_TRIGGER_FROM_SAVI_APPLY_ACTIONS,
  CLEAR_SAVI_ACTIONS_FILTER,
  GET_SAVI_COMPANION_STATUS_LOAD,
  GET_SAVI_COMPANION_STATUS_SUCCESS,
  SET_IS_CERTIFICATE_ACTIONABLE,
  SET_IS_SAVI_COMPANION_ENABLED,
  SET_IS_SAVI_FILTER_APPLIED,
} from '../types';

const INITIAL_STATE = {
  isSaviApplied: null,
  showIntro: false,
  isSaviEnabled: false,
  statusDetails: { smartActionDetails: {} },
  isCertificationActionable: false,
  isTriggeredFromSaviApplyActions: false,
  clearSaviActionsFilter: false,
  appliedSaviFilters: {
    smartFilter: '',
    actionFilters: [],
  },
};

const saviCompanionReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case SET_IS_SAVI_FILTER_APPLIED:
      return {
        ...state,
        isSaviApplied: action.payload,
      };

    case GET_SAVI_COMPANION_STATUS_LOAD:
      return {
        ...state,
        statusDetails: {
          ...state.statusDetails,
          loading: true,
        },
      };

    case GET_SAVI_COMPANION_STATUS_SUCCESS:
      return {
        ...state,
        statusDetails: {
          ...state.statusDetails,
          loading: false,
          smartActionDetails: {
            savi_approve: { ...action.payload.savi_approve },
            savi_revoke: { ...action.payload.savi_revoke },
          },
        },
      };

    case SET_IS_SAVI_COMPANION_ENABLED:
      return {
        ...state,
        isSaviEnabled: action.payload,
      };

    case APPLY_SAVI_COMPANION_ACTIONS_LOAD:
      return {
        ...state,
        isApplyActionLoading: true,
      };

    case APPLY_SAVI_COMPANION_ACTIONS_SUCCESS:
      return {
        ...state,
        statusDetails: {},
        isApplyActionLoading: false,
      };

    case SET_IS_CERTIFICATE_ACTIONABLE:
      return {
        ...state,
        isCertificationActionable: action.payload,
      };

    case CERT_DETAILS_TRIGGER_FROM_SAVI_APPLY_ACTIONS:
      return {
        ...state,
        isTriggeredFromSaviApplyActions: action.payload,
      };

    case CLEAR_SAVI_ACTIONS_FILTER:
      return {
        ...state,
        clearSaviActionsFilter: action.payload,
      };

    case APPLIED_SAVI_ACITONS_FILTER:
      return {
        ...state,
        appliedSaviFilters: {
          ...state.appliedSaviFilters,
          actionFilters: action.payload,
        },
      };

    case APPLIED_SAVI_SMART_FILTER:
      return {
        ...state,
        appliedSaviFilters: {
          ...state.appliedSaviFilters,
          smartFilter: action.payload,
        },
      };

    default:
      return state;
  }
};

export default saviCompanionReducer;
